import axios from 'axios'

const API_ENDPOINT = 'tracks'

export default {

    all(data) {
        return axios.get(API_ENDPOINT, {params: data})
    },

    find(label, album, track) {
        return axios.get(API_ENDPOINT + '/' + label + '/' + album + '/' + track)
    }
}
